<template>
  <div class="parent_div" id="dc_customize">
    <dd-header
      ref="menuRef"
    />
    <div class="wrapper">
      <!-- メインコンテンツ -->
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <h1 class="hidden">商品カスタマイズ</h1>
          <section>
            <h2 class="hidden">商品情報</h2>
            <div id="product_header">
              <div class="product_info">
                <div class="product_name">{{targetPlan.dcFdName}}</div>
              </div>
            </div>
            <div class="product_data">
              <div id="product-big-image">
                <img :src="getImage(targetPlan.dcFdImageB)">
              </div>
              <!-- 施工事例 -->
              <div id="construct" v-if="constructList && constructList.length > 0">
                <div class="pc_construct">
                  <div v-for="(product, index) in constructList" class="construct" :key="'construct-' + index" :value="product">
                    <img :src="product.img" @click="previewConstruct(product)">
                  </div>
                </div>
                <div class="pc_hidden">
                  <dd-consturct
                    ref="ddCategoryListRef"
                    :swipeList="constructList"
                    :swiperOptions="constructOptions"
                    :horizontalMode="false"
                    @clickImage="previewConstruct"
                  />
                </div>
              </div>
            </div>
            <div class="product_option">
                <div class="manual">
                  <span @click="downloadManual(targetPlan.cDcProductManual)" v-bind:class="{disabled : !targetPlan.cDcProductManual}">
                    <img :src="getYaImage('common/icon_pdf.svg')">
                    <figcaption>商品説明書ダウンロード</figcaption>
                  </span>
                  <span @click="downloadManual(targetPlan.cDcConstructManual)" v-bind:class="{disabled : !targetPlan.cDcConstructManual}">
                    <img :src="getYaImage('common/icon_pdf.svg')">
                    <figcaption>設置説明書ダウンロード</figcaption>
                  </span>
                  <span @click="downloadManual(targetPlan.cDcUserManual)" v-bind:class="{disabled : !targetPlan.cDcUserManual}">
                    <img :src="getYaImage('common/icon_pdf.svg')">
                    <figcaption>取扱説明書ダウンロード</figcaption>
                  </span>
                </div>
              </div>
          </section>
          <section class="product_size_section">
            <h3>{{sizeInputTitle}}</h3>
            <div>
              <div id="product_size" class="product_tab_content">
                <div v-if="isTypeBeamCounter">
                  <dd-param-shaped-l
                    ref="paramCommonRef"
                    :targetPlan="targetPlan"
                  />
                </div>
                <div v-else-if="isParamShelfBoard">
                  <dd-param-size2
                    ref="paramCommonRef"
                    :targetPlan="targetPlan"
                    :isDisableForm="isSpaceJoincd"
                    :isExecOrder="isExecOrder"
                    :isShelf="isShelf"
                    :isShelfType="isShelfType"
                  />
                </div>
                <div v-else-if="categoryType==4">
                  <dd-param-size
                    ref="paramCommonRef"
                    :targetPlan="targetPlan"
                    :isDisableForm="isSpaceJoincd"
                    :isExecOrder="isExecOrder"
                    @changeWallFlag="changeWallFlag"
                  />
                </div>
                <div v-else>
                  <dd-param-size-filler
                    ref="paramCommonRef"
                    :targetPlan="targetPlan"
                    :isDisableForm="isSpaceJoincd"
                    :isExecOrder="isExecOrder"
                    :isStruct="isResearch"
                    :isExistEndPanel="isExistEndPanel"
                    :isMiura="isMiuraCompany"
                  />
                </div>
              </div>
            </div>
          </section>
          <section class="color_section">
            <h3>■商品カラーの選択</h3>
            <p>※ カラー画像について、ご利用のパソコン・スマートフォンのモニターによってカラーの見え方が違ったり、実際の商品と色味や色柄が異なる場合がございます。予めご了承頂きますようお願いいたします。</p>
            <div id="color-door-style" v-if="colorStyleList.length > 0">
              <dd-color-style
                ref="styleColorDoor"
                :title="'扉/エンドパネル/カウンター'"
                :styleList="colorStyleList"
                :selectColorStyle="selectColorStyle"
                @changeColorStyle="changeColorStyle"
              />
            </div>
            <div class="space"></div>
            <div id="color-door" v-if="doorColorList.length > 0">
              <dd-color-pallet
                ref="colorPalletDoor"
                :documentId="'doorId'"
                :title="doorColorTitle"
                :colorList="doorColorList"
                :color="colorDoor"
                @selectColor="selectDoorColor"
              />
            </div>
            <div class="space"></div>
            <div id="color-counter" v-if="counterColorList.length > 0">
              <dd-color-pallet
                ref="colorPalletCounter"
                :documentId="'counterId'"
                :title="'カウンターカラーを選択ください'"
                :colorList="counterColorList"
                :color="colorCounter"
                @selectColor="selectCounterColor"
              />
            </div>
            <div id="color-cabine" v-if="cabineColorList.length > 0">
              <dd-color-pallet
                ref="colorPalletCabine"
                :documentId="'cabineId'"
                :title="'キャビネット/棚/脚カラーを選択ください'"
                :colorList="cabineColorList"
                :color="colorCabine"
                @selectColor="selectCabineColor"
              />
            </div>
            <div class="separate_line"></div>
          </section>
          <section>
            <div v-if="targetPlan.dcCategoryType==5" class="product_tab_content">
              <h3>■ご注文数を選択ください</h3>
              <div class="content_line">
                <label>ご注文数</label>
                <input type="text" v-model="dcBoardCount" @keypress="validateNumber" @input="dcBoardCount=inputRestNumber($event)" @blur="onBlurOpBoardCount" maxlength="2">枚
              </div>
            </div>
            <div id="customize_option" class="product_tab_content" v-else-if="targetPlan.dcCategoryType!==4 && !(targetPlan.opShelfType===1 && targetPlan.opFillerType===1)">
              <h3>■追加部材をご選択ください。</h3>
              <div class="input_btn_area">
                <div>
                  <div class="content_line" v-if="targetPlan.opShelfType!==1">
                    <div>
                      <div>可動棚</div>
                      <div>
                        <label class="option_check">
                          <input type="checkbox" :id="'opt_shelf'" v-model="isAddShelf" :disabled="targetPlan.opShelfType==2"/>
                          <span class="opt_check"></span>
                          <span class="opt_label">追加</span>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div>
                        <label class="opt_text">枚/列を入力</label>
                      </div>
                      <div>
                        <input type="text" v-model="dcShelfCount" @keypress="validateNumber" @input="dcShelfCount=inputRestNumber($event)" @blur="onBlurOpShelfCount" maxlength="2" :disabled="!isAddShelf">
                      </div>
                      <div>※列ごとに指定枚数追加されます。</div>
                    </div>
                  </div>
                  <div class="content_line" v-if="targetPlan.opFillerType!==1">
                    <div>
                      <div>フィラー</div>
                      <div>
                        <label class="option_check">
                          <input type="checkbox" :id="'opt_filler'" v-model="isAddFiller" :disabled="targetPlan.opFillerType==2"/>
                          <span class="opt_check"></span>
                          <span class="opt_label">追加</span>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div>
                        <label class="opt_text">本数を入力</label>
                      </div>
                      <div>
                        <input type="text" v-model="dcFillerCount" @keypress="validateNumber" @input="dcFillerCount=inputRestNumber($event)" @blur="onBlurOpFillerCount" maxlength="2" :disabled="!isAddFiller">
                      </div>
                      <div>※追加フィラーの寸法は、{{fillerSize}}mm×200mm×1800mmです。</div>
                    </div>
                  </div>
                </div>
                <!-- <div>
                  <div class="detail_btn3" @click="route('SupportInput', targetPlan.dcFdId)">この商品について問い合わせる</div>
                </div> -->
              </div>
            </div>
            <div class="separate_line" v-if="targetPlan.dcCategoryType==5 || (targetPlan.dcCategoryType!==4 && !(targetPlan.opShelfType===1 && targetPlan.opFillerType===1))"></div>
          </section>
          <section id="input_delivery">
            <h3>■ お届け先郵便番号の入力</h3>
            <div>
              <label :for="'delivery_input_address'">郵便番号（半角、ハイフンなし）</label>
            </div>
            <div>
              <div>
                <input type="text" v-model="deliveryForm.postcd" @keypress="validateNumber" @input="deliveryForm.postcd=convertHalfNumber($event)" oninput="if(value.length>7)value=value.slice(0,7)" ><br>
              </div>
              <div v-if="errors.deliveryPostcd" class="error_text middle_text">{{errors.deliveryPostcd}}</div>
            </div>
            <div class="separate_line"></div>
          </section>
          <section id="input_construct" v-if="isViewConstruct">
            <h3>■ 組立設置サービスの選択</h3>
            <div class="input_btn_area">
              <div>
                <div id="construction">
                  <div class="radio_check">
                    <input type="radio" name="construction_radio" id="construction_no" :class="{radio_no: isSelectConstruct, radio_no_disable: !isSelectConstruct}" checked="" value=0 v-model.number="workFlag" />
                    <label for="construction_no" class="radio-label">なし</label>
                  </div>
                  <div class="radio_check">
                    <input type="radio" name="construction_radio" id="construction_need" :class="{radio_need: isSelectConstruct, radio_need_disable: !isSelectConstruct}" value=1 v-model.number="workFlag" />
                    <label for="construction_need" class="radio-label">あり</label>
                  </div>
                </div>
                <div class="small_text">※組立設置をご希望の場合、担当者よりご連絡いたします。</div>
                <div class="red" v-if="isOtherContruct">※水道工事、電気工事は承れませんので、ご自身での手配をお願いいたします。</div>
                <div class="customize_order" v-if="isConstruct">
                  <div class="radio_check">
                    <input type="radio" id="const_someaddress" name="struct_address" @change="changeNewStruct()" :value="true" v-model="isStructSameAddress"/>
                    <label :for="'const_someaddress'" class="radio-label">納品先と同じ住所</label>
                  </div>
                  <div class="radio_check">
                    <input type="radio" id="const_differ" name="struct_address" @change="changeNewStruct()" :value="false" v-model="isStructSameAddress"/>
                    <label :for="'const_differ'" class="radio-label">納品先住所と異なる住所の郵便番号</label>
                    <label :for="'const_differ'" class="sub_label">（半角、ハイフンなし）</label>
                  </div>
                  <div>
                    <div v-bind:class="{disable_form: isStructSameAddress, address_form: true}">
                      <input type="text" v-model="constructForm.postcd" @keypress="validateNumber" @input="constructForm.postcd=convertHalfNumber($event)" oninput="if(value.length>7)value=value.slice(0,7)" ><br>
                    </div>
                    <div v-if="errors.constructPostcd" class="error_text middle_text">{{errors.constructPostcd}}</div>
                  </div>
                  <div class="customize_sub">
                    <div>※</div>
                    <div>
                      <ul>
                        <li>組立設置オプションには以下の費用が発生します。</li>
                        <li>組立技術料：組立作業費および副資材、簡易養生材など。</li>
                        <li>諸経費：交通費、燃料代など。</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="separate_line"></div>
          </section>
          <section class="product_order_cost">
            <div id="product_order" class="n_separator">
              <div class="order_cost">
                <div>{{itemName}}</div>
                <div></div>
                <div>{{formatPrice(priceData.itemPrice * priceData.productCount)}}</div>
              </div>
              <div class="order_cost">
                <div>配送料</div>
                <div></div>
                <div>{{formatPrice(priceData.delivaryPrice * priceData.productCount)}}</div>
              </div>
              <div class="order_cost">
                <div>消費税</div>
                <div></div>
                <div>{{formatPrice(priceData.subTotalTax)}}</div>
              </div>
              <div class="separate_line2"></div>
              <div class="order_cost">
                <div>商品・配送費小計</div>
                <div></div>
                <div>{{formatPrice(priceData.subTotalPrice + priceData.subTotalTax)}}</div>
              </div>
              <div class="separate_line2"></div>
              <div v-if="workFlag">
                <div class="order_cost">
                  <div>組立技術料</div>
                  <div></div>
                  <div>{{formatPrice(priceData.constructPrice * priceData.productCount)}}</div>
                </div>
                <div class="order_cost" v-if="priceData.carryInPrice">
                  <div>受け取り搬入サービス費</div>
                  <div></div>
                  <div>{{formatPrice(priceData.carryInPrice * priceData.productCount)}}</div>
                </div>
                <div class="order_cost">
                  <div>諸経費</div>
                  <div></div>
                  <div>{{formatPrice(priceData.executionVarExpensesPrice)}}</div>
                </div>
                <div class="order_cost">
                  <div>消費税</div>
                  <div></div>
                  <div>{{formatPrice(priceData.constructTotalTax)}}</div>
                </div>
                <div class="separate_line2"></div>
                <div class="order_cost">
                  <div>組立設置他サービス小計（税込）</div>
                  <div></div>
                  <div>{{formatPrice(priceData.constructTotalPrice + priceData.constructTotalTax)}}</div>
                </div>
              </div>
              <div class="separate_line" v-if="workFlag"></div>
              <div class="lds-sub-spinner" v-show="createPlanFlag===true">
                <div class="lds-spinner lds-spinner-pos">
                  <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
                </div>
              </div>
              <div class="product_order_line total_price">
                <div>
                  <div>合計金額（税込）</div>
                </div>
                <div class="space"></div>
                <div class="price big_text2 bold" v-if="resrchFlag">{{formatPrice(priceData.resrchTotalPrice)}}</div>
                <div class="price big_text2 bold" v-else-if="!isPlanning">{{formatPrice(priceData.totalTax)}}</div>
                <div class="price big_text2 bold" v-else>{{priceCalcText}}</div>
              </div>
              <div class="order_action_area">
                <div></div>
                <div class="action_area">
                  <div v-bind:class="{main_btn: true, act_sub_btn: true, disabled: !isExecOrder}" @click="onReEstimate()" v-on:mouseover="isOnReload(true)" v-on:mouseleave="isOnReload(false)" v-if="false">
                    <img :src="imgReload" class="icon">
                    <a>再計算</a>
                  </div>
                  <!-- <div v-bind:class="{main_btn: true, act_sub_btn2: true}" @click="save()" v-on:mouseover="isOnSave(true)" v-on:mouseleave="isOnSave(false)" v-if="!isGuestUser">
                    <img :src="imgSave" class="icon">
                    <a>入力内容保存</a>
                  </div> -->
                  <template v-if="resrchFlag">
                    <div class="main_btn sel_main_btn" @click="resrch()">
                      <a>事前現場調査見積り</a>
                    </div>
                  </template>
                  <template v-else>
                    <div class="order_counter">
                      <dd-counter
                        ref="ddCounterRef"
                        :initCount="targetPlan.dcProductCount"
                        v-if="targetPlan.dcCategoryType!==5 && !resrchFlag"
                      />
                      <div v-else></div>
                    </div>
                    <div v-bind:class="{main_btn:true, sel_main_btn: true, disabled: !isExecOrder}" @click="onShowEstimateModal()">
                      <a>{{estimteBtnTitle}}</a>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div><!-- end main-content -->
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>

import axios from 'axios'
import {mapActions, mapState} from 'vuex'

// common
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as AppEc from '../utils/AppEc'
import * as Check from '../../utils/Check'

import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'

import ColorStyle from '../components/top/input/color/DcColorStyle'
import ColorPallet from '../components/top/input/color/DcColorPallet'
import ParamSize from '../components/top/input/paramater/DcParamSize'
import ParamSize2 from '../components/top/input/paramater/DcParamSize2'
import ParamSizeFiller from '../components/top/input/paramater/DcParamSizeFiller'
import ParamSizeShapedL from '../components/top/input/paramater/DcParamSizeShapedL'
import {COLOR_MATERIAL_TYPE} from '../constants/TypeEc'
import {DC_URL, DC_STORAGE_KEY, DC_PRPIC_ON} from '../../constants/App'
import * as FormUtil from '../../utils/FormUtil'
import SwiperH from '../components/common/SwiperH'
import DcCounter from '../components/common/DcCounter'
import ToolTip from '../../components/common/ToolTip'
import LoadingModal from '../../components/common/LoadingModal'

// const
const CART_PRODUCT_MAX_COUNT = 30

export default {
  name: 'DcCustomize',
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap,
    'dd-color-style': ColorStyle,
    'dd-color-pallet': ColorPallet,
    'dd-param-size': ParamSize,
    'dd-param-size2': ParamSize2,
    'dd-param-size-filler': ParamSizeFiller,
    'dd-param-shaped-l': ParamSizeShapedL,
    'dd-consturct': SwiperH,
    'dd-counter': DcCounter,
    'tool-tip': ToolTip,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'dcProduct',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'}
      ],
      id: '',
      // 空間情報
      spaceJoincd: '',
      targetPlan: {
        corpData: {corpName: ''}
      },
      colorList: [],
      colorDoor: {},
      colorCabine: {},
      colorCounter: {},
      selectPostcd: {},
      isAddShelf: false,
      isAddFiller: false,
      dcShelfCount: 0,
      dcBoardCount: 1,
      dcFillerCount: 0,
      // 見積り関連
      businessId: '',
      selBusiness: {},
      saveForm: {},
      saveConstructForm: {},
      isExistDelivery: false,
      isStructSameAddress: true,
      itemName: '',
      deliveryForm: {
        id: '',
        postcd: '',
        state: '',
        city: '',
        street: ''
      },
      constructForm: {
        id: '',
        postcd: '',
        state: '',
        city: '',
        street: ''
      },
      resrchForm: {
        postcd: '',
        state: '',
        city: '',
        street: ''
      },
      isNetOn: false,
      copyForm: {},
      priceData: {},
      profitPriceData: {},
      profitPercent: undefined,
      // commonList: [],
      constructList: [],
      isOrder: false,
      workFlag: 0,
      constructOpFlag: 0,
      resrchFlag: 0,
      leftSide: '',
      rightSide: '',
      isCounter: false,
      // エラー
      errors: {},
      // フィラー・エンドパネルの設定
      isLeftFilter: false,
      isLeftEndPanel: false,
      isRightFilter: false,
      isRightEndPanel: false,
      // tabType: 1,
      isResrchSameAddress: true,
      label: {
        postcd: '郵便番号'
      },
      userInfo: {},
      planListOptions: {
        slidesPerGroup: 1,
        slidesPerView: 1,
        initialSlide: 0,
        slidesPerColumn: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        SimulateTouch: true,
        touchStartPreventDefault: false,
        preventClicks: true
        // spaceBetween: 5
      },
      buyFlag: false,
      updateFlag: false,
      saveFlag: false,
      estimateFlag: false,
      doResrchFlag: false,
      imgQmark: App.getMmstyleResource('common/qmark_gray.svg'),
      createPlanFlag: false,
      runPlanList: [],
      priceCalcText: '計算中',
      priceCalcTimer: undefined,
      deliErrMessage: ['恐れ入りますが、ご入力いただいた地域への配送は別途の調整となります。',
        '画面上部「お問い合わせ」より、ご希望の商品と納品先のご住所をご連絡ください。',
        '　',
        '納品先調整地域：北海道全域、沖縄全域、四国一部地域、離島など一部地域。',
        '組立設置先：制限なし(全国対応)'
      ],
      isWallEmbedded: false,
      constructOptions: {
        slidesPerView: 'auto',
        slidesPrGroup: 2,
        slidesPerColumn: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        SimulateTouch: true,
        touchStartPreventDefault: false,
        preventClicks: true,
        centeredSlides: false,
        spaceBetween: 10,
        initialSlide: 0
      },
      selectManual: {},
      manualList: [
        {id: 1, name: '基本仕様'},
        {id: 2, name: '金属・部品仕様'},
        {id: 3, name: '扉カラー'}
      ],
      isMenuActive: false,
      // カラースタイル
      colorStyleList: [],
      selectColorStyle: {},
      categoryType: 0,
      dtype: undefined,
      imgReload: this.getImage('common/reload_black.svg'),
      imgSave: this.getImage('common/save_black.svg'),
      imgCalc: this.getImage('common/calculator.svg')
    }
  },
  methods: {
    ...mapActions({getCartData: 'loadCartData', getDeliveryDestList: 'loadDeliveryDest'}),
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    },
    syncLogin: async function (id) {
      let param = {
        dcFdId: id
      }
      await this.guestLogin()
      await this.selectPlan(param)
      await this.createPlan(this.topForm)
    },
    defaultPlan: async function (id) {
      let param = {
        dcFdId: id
      }
      await this.selectPlan(param)
      await this.createPlan(this.topForm)
    },
    readSaveParam: async function (id, param) {
      await this.selectPlan(param)
      await this.setSaveParam(param)
      await this.createPlan(this.topForm)
    },
    guestLogin: async function () {
      console.log('guest login')
      this.$refs.loadingModalRef.showModal(true)
      await axios.get(DC_URL.LOGIN + '/guest')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.userInfo = response.data.data
            console.log('set guest user:' + Object.entries(this.userInfo))
            App.setLocalStorage(DC_STORAGE_KEY.USER_INFO, this.userInfo)
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    // 公開プランの選択、ローカルプランの作成
    selectPlan: async function (param) {
      console.log('select plan start')
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          dcFdId: param.dcFdId
        }
      }
      await axios.get(DC_URL.TOP + '/select', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.selectedPlan(response.data.data)
            console.log('select end')
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          console.log('select finally')
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    setSaveParam: async function (param) {
      console.log('setSaveParam start')
      let targetPlan = this.targetPlan
      this.$set(targetPlan, 'dcWidth', param.dcWidth)
      this.$set(targetPlan, 'dcHeight', param.dcHeight)
      this.$set(targetPlan, 'dcHeight2', param.dcHeight2)
      this.$set(targetPlan, 'dcDepth', param.dcDepth)
      this.$set(targetPlan, 'dcDepth2', param.dcDepth2)
      this.$set(targetPlan, 'dcBSize', param.dcBSize)
      this.$set(targetPlan, 'dcCSize', param.dcCSize)
      this.$set(targetPlan, 'dcDSize', param.dcDSize)
      this.$set(targetPlan, 'dcBType', param.dcBType)
      this.$set(targetPlan, 'dcCType', param.dcCType)
      this.$set(targetPlan, 'dcDType', param.dcDType)
      this.targetPlan = Object.assign({}, targetPlan)
      // 初期カラー選択
      this.$nextTick(function () {
        if (param.dcColorDoorDetail) {
          this.selectDoorColor(param.dcColorDoorDetail)
        } else {
          this.selectDoorColor(null)
        }
        if (param.dcColorBoxDetail) {
          this.selectCabineColor(param.dcColorBoxDetail)
        } else {
          this.selectCabineColor(null)
        }
        if (param.dcColorCounterDetail) {
          this.selectCounterColor(param.dcColorCounterDetail)
        } else {
          this.selectCounterColor(null)
        }
        console.log('selectedPlan end color')
      })
      // 追加可動棚の設定
      if (param.dcShelfCount && param.dcShelfCount > 0) {
        this.isAddShelf = true
        this.dcShelfCount = param.dcShelfCount
      } else {
        this.isAddShelf = false
      }
      if (param.dcFillerCount && param.dcFillerCount > 0) {
        this.isAddFiller = true
        this.dcFillerCount = param.dcFillerCount
      } else {
        this.isAddFiller = false
      }
      // 納品先のみ込み
      if (!Check.isNullOrUndefined(param.businessId)) {
        // 納品先読み込み
        this.isExistDelivery = param.dcSaveExistDeliFlag
        let business = this.addressList.find(a => a.businessId === param.businessId)
        if (business !== undefined) {
          this.$set(this.deliveryForm, 'postcd', param.dcSaveDeliPostcd)
          this.selBusiness = business
        } else {
          // 削除済み
          this.selBusiness = {}
        }
      } else {
        // 入力
        this.isExistDelivery = false
        this.$set(this.deliveryForm, 'postcd', param.dcSaveDeliPostcd)
      }
      // 組立施工読み込み
      this.workFlag = param.dcWorkFlag ? 1 : 0
      this.isStructSameAddress = param.dcStructSameAddressFlag
      this.$set(this.constructForm, 'postcd', param.dcStructPostcd)
      this.constructOpFlag = param.dcConstructOpServiceFlag ? 1 : 0
      // 事前現場調査読み込み
      this.resrchFlag = param.dcSaveResrchFlag ? 1 : 0
      this.$set(this.resrchForm, 'postcd', param.dcSaveResrchPostcd)
      this.isResrchSameAddress = param.dcSaveSameAddressFlag

      // 棚板のご注文数を保持
      if (param.categoryId === 5) {
        this.dcBoardCount = param.dcShelfCount ? param.dcShelfCount : 0
      } else {
        this.$set(this.targetPlan, 'dcProductCount', param.dcProductCount)
      }
      console.log('setSaveParam end')
    },
    // セットプラン選択後のクライアント側の対応
    selectedPlan: function (data) {
      console.log('start selectedPlan')
      this.targetPlan = Object.assign({}, this.convertDcFileData(data.dcFileData))
      // ぱんくずの設定
      this.pageList = []
      this.pageList.push({id: 'dcTop', key: 'dcTop', title: 'トップページ', route: 'DcTop'})
      if (DC_PRPIC_ON === 1) {
        this.pageList.push({id: 'dcCategory', key: 'dcCategory', title: this.targetPlan.categoryName, route: 'DcPrpic', query: {cid: this.targetPlan.dcCategoryType}})
      } else {
        this.pageList.push({id: 'dcCategory', key: 'dcCategory', title: this.targetPlan.categoryName, route: 'DcCategory', query: {cid: this.targetPlan.dcCategoryType}})
      }
      this.pageList.push({id: 'dcProduct', key: 'dcProduct', title: this.targetPlan.dcFdName})
      // カラースタイルを設定
      this.colorStyleList = []
      data.colorStyleList
        .forEach(e => {
          let style = {
            colorStyleId: e.colorStyleId,
            corpId: e.corpId,
            colorTypeNo: e.colorTypeNo,
            colorStyleNo: e.colorStyleNo,
            colorStyleName: e.colorStyleName,
            colorStyleImage: this.getImage('style/' + e.colorStyleImage)
          }
          this.colorStyleList.push(style)
        })
      // 初期カラースタイル選択
      if (this.colorStyleList.length > 0) {
        this.selectColorStyle = this.colorStyleList[0]
      } else {
        this.selectColorStyle = {}
      }
      // カラーリストを設定
      this.colorList = []
      data.dcColorList
        .forEach(e => {
          let color = {
            id: e.no,
            name: e.name,
            type: e.type,
            style: e.colorStyleNo,
            no: e.dispNo,
            img: this.getImage('color/' + e.img),
            imgB: this.getImage('color/' + this.bigImage(e.img))
          }
          this.colorList.push(color)
        })
      // 初期カラー選択
      this.$nextTick(function () {
        if (this.doorColorList.length > 0) {
          let color = this.doorColorList.find(c => c.id === data.dcParamModel.dcColorDoor)
          this.selectDoorColor(color !== undefined ? color : this.doorColorList[0])
        } else {
          this.selectDoorColor(null)
        }
        if (this.cabineColorList.length > 0) {
          let color = this.cabineColorList.find(c => c.id === data.dcParamModel.dcColorBox)
          this.selectCabineColor(color !== undefined ? color : this.cabineColorList[0])
        } else {
          this.selectCabineColor(null)
        }
        if (this.counterColorList.length > 0) {
          let color = this.counterColorList.find(c => c.id === data.dcParamModel.dcColorCounter)
          this.selectCounterColor(color !== undefined ? color : this.counterColorList[0])
        } else {
          this.selectCounterColor(null)
        }
        console.log('selectedPlan end color')
      })
      // 追加可動棚の設定
      if (data.dcParamModel.dcShelfCount && data.dcParamModel.dcShelfCount > 0) {
        this.isAddShelf = true
        this.dcShelfCount = data.dcParamModel.dcShelfCount
      } else {
        this.isAddShelf = false
      }
      if (data.dcParamModel.dcFillerCount && data.dcParamModel.dcFillerCount > 0) {
        this.isAddFiller = true
        this.dcFillerCount = data.dcParamModel.dcFillerCount
      } else {
        this.isAddFiller = false
      }

      // 組立設置例の設定
      this.constructList = []
      data.constructList
        .forEach(c => {
          let construct = {
            id: c.id,
            dcFdId: c.dcFdId,
            price: c.price,
            img: this.getImage('top/construct/' + c.img),
            imgB: this.getImage('top/construct/' + this.bigImage(c.img))
          }
          this.constructList.push(construct)
        })
      console.log('end selectedPlan')
    },
    createPlan: function (param) {
      let payload = Object.assign({}, param)
      console.log('start create ' + param.dcFdId)
      this.createPlanFlag = true
      axios.post(DC_URL.TOP + '/create', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            console.log('ret create ' + param.dcFdId)
            this.spaceJoincd = response.data.data.spaceJoincd
            // this.priceData = response.data.data.priceData
            this.priceData = Object.assign({}, response.data.data.priceData)
            this.profitPriceData = Object.assign({}, response.data.data.profitPriceData)
            // Object.assign({}, this.priceData, response.data.data.priceData)
            this.profitPercent = response.data.data.priceData.profitPercent
            this.itemName = response.data.data.itemName
            this.clearPriceCalcTimer()
            // this.nextPlan()
            this.createPlanFlag = false
            console.log('end create ' + param.dcFdId)
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          console.log('finaly create ' + param.dcFdId)
        })
    },
    onReEstimate: async function () {
      try {
        console.log('do update1')
        if (this.updateFlag) return
        console.log('do update2')
        this.updateFlag = true
        this.$refs.loadingModalRef.showModal(true)
        await this.postcdCompleteDelivery()
        await this.postcdCompleteStruct()
        await this.postcdCompleteResrch()
        if (!this.checkInputParam()) {
          console.log('Failed to check input parameters')
          return
        }
        await this.update()
      } catch (error) {
        console.log('doupdate cacth')
      } finally {
        console.log('doupdate finally')
        this.updateFlag = false
        this.$refs.loadingModalRef.showModal(false)
      }
    },
    // ローカルプランの更新
    update: async function () {
      console.log('update')
      let payload = this.topForm
      await axios.post(DC_URL.TOP + '/update', payload
      )
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            // 金額とファイルを更新
            // this.priceData = response.data.data.priceData
            // Object.assign({}, this.priceData, response.data.data.priceData)
            // Object.assign({}, this.profitPriceData, response.data.data.profitPriceData)
            this.priceData = Object.assign({}, response.data.data.priceData)
            this.profitPriceData = Object.assign({}, response.data.data.profitPriceData)
            this.profitPercent = response.data.data.priceData.profitPercent
            this.spaceJoincd = response.data.data.spaceJoincd
          }
        }).catch(error => {
          Api.handleError(error)
        })
    },
    save: async function () {
      if (this.saveFlag) return
      this.saveFlag = true
      // this.$refs.loadingModalRef.showModal(true)
      await this.postcdCompleteDelivery()
      await this.postcdCompleteStruct()
      await this.postcdCompleteResrch()
      if (!this.checkInputParam()) {
        console.log('Failed to check input parameters')
        this.saveFlag = false
        // this.$refs.loadingModalRef.showModal(false)
        return
      }
      let modalData = {
        title: '',
        messages: ['保存名を入力してください。'],
        modalType: 'confirm',
        textAlign: 'center',
        okBtnLabel: '保存',
        callbackParams: {},
        onOk: (callback) => {
          let payload = this.topForm
          this.$set(payload, 'saveName', callback.saveName)
          this.$refs.loadingModalRef.showModal(true)
          axios.post(DC_URL.SAVE, payload
          ).then(response => {
            if (response.data.errorMessage) {
              this.handleErrorMessage(response)
              this.$refs.loadingModalRef.showModal(false)
            } else {
              console.log('show save dialog')
              AppEc.showModal({
                title: '',
                messages: ['商品情報が保存されました'],
                messageType: 'success',
                layoutType: 'layout-classic',
                modalType: 'confirm',
                textAlign: 'center',
                okBtnLabel: '閉じる',
                cancelBtnLabel: '保存リスト',
                onOk: () => {
                  // 特になし
                  console.log('save dialog click ok button')
                },
                onCancel: () => {
                  this.$router.push({
                    name: 'SaveItemList'
                  })
                }
              })
            }
          }).catch(error => {
            Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
            AppEc.showModal({
              title: 'システムエラー',
              messages: ['何らかの理由で不具合が発生しました。\nもう一度ページを開き直しても正しく表示されない時は、しばらく時間をおいてからお試しください。'],
              messageType: 'error',
              textAlign: 'left'
            })
          }).finally(() => {
            console.log('save finally')
            this.$refs.loadingModalRef.showModal(false)
          })
        }
      }
      AppEc.showProductSave(modalData)
      this.saveFlag = false
    },
    // 見積り・図面ダイアログを表示
    onShowEstimateModal: async function () {
      console.log('run planning data. ' + this.runPlanList.length)
      console.log('create plan flag. ' + this.createPlanFlag)
      // 多重防止
      if (this.estimateFlag) return
      this.estimateFlag = true
      this.$refs.loadingModalRef.showModal(true)
      // await Promise.all([this.postcdCompleteDelivery(), this.postcdCompleteStruct()])
      await this.postcdCompleteDelivery()
      await this.postcdCompleteStruct()
      await this.postcdCompleteResrch()
      // チェック処理
      if (!this.checkInputParam()) {
        this.$refs.loadingModalRef.showModal(false)
        this.estimateFlag = false
        return
      }
      // 画面データを渡す
      let payload = this.topForm
      axios.post(DC_URL.TOP + '/order', payload
      )
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            this.$refs.loadingModalRef.showModal(false)
          } else {
            // 金額とファイルを更新
            this.priceData = Object.assign({}, response.data.data.priceData)
            this.profitPriceData = Object.assign({}, response.data.data.profitPriceData)
            this.spaceJoincd = response.data.data.spaceJoincd
            // ダイアログ表示
            let modalData = {
              onOk: () => {
                this.buy(response.data.data.constructOpAddressData)
              },
              showSuccess: () => {
                this.$refs.loadingModalRef.showModal(false)
                document.body.style.overflow = 'hidden'
              },
              dcFdId: this.targetPlan.dcFdId,
              fileName: this.itemName,
              titleDoor: '扉カラー',
              colorDoor: this.colorDoor,
              titleCabine: 'キャビネット/棚/脚カラー',
              colorCabine: this.colorCabine,
              titleCounter: 'カウンターカラー',
              colorCounter: this.colorCounter,
              priceData: this.priceData,
              targetPlan: this.topForm,
              spaceJoincd: this.spaceJoincd,
              dispOrderButton: true,
              dcProductCount: this.productCount,
              isCalcDelivery: true,
              isDrawing: this.targetPlan.dcCategoryType !== 5,
              corpData: this.targetPlan.corpData,
              isProductData: true,
              consentImg: this.targetPlan.consentImg
            }
            AppEc.showEstimateModal(modalData)
            this.estimateFlag = false
          }
        }).catch(error => {
          document.body.style.overflow = 'scroll'
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
          this.$refs.loadingModalRef.showModal(false)
          AppEc.showModal({
            title: 'システムエラー',
            messages: ['何らかの理由で不具合が発生しました。\nもう一度ページを開き直しても正しく表示されない時は、しばらく時間をおいてからお試しください。'],
            messageType: 'error',
            textAlign: 'left'
          })
        }).finally(() => {
          this.estimateFlag = false
        })
    },
    onNet: function () {
      this.isNetOn = !this.isNetOn
    },
    onCgOuput: function () {
      let modalData = {
        onOk: (callback) => {
          this.$refs.loadingModalRef.showModal(true)
          let payload = this.topForm
          this.$set(payload, 'cameraPos', callback.cameraPosition)
          axios.post(DC_URL.TOP + '/cg', this.topForm)
            .then(response => {
              if (response.data.errorMessage) {
                this.handleErrorMessage(response)
                this.$refs.loadingModalRef.showModal(false)
              } else {
                App.showModal({
                  messages: ['※出力物はメールで送られます。']
                })
                this.$refs.loadingModalRef.showModal(false)
              }
            }).catch(error => {
              let retError = Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
              App.showModal({
                title: 'システムエラー',
                messages: [retError.errorMessage],
                messageType: 'error',
                textAlign: 'left'
              })
              this.$refs.loadingModalRef.showModal(false)
            })
        }
      }
      AppEc.showCameraPosModal(modalData)
    },
    buy: function () {
      if (this.nowList.length >= CART_PRODUCT_MAX_COUNT) {
        document.body.style.overflow = 'scroll'
        AppEc.showModal({
          messages: ['カートに追加できる商品は' + CART_PRODUCT_MAX_COUNT + '個までになります。']
        })
        return
      }
      // 多重防止
      if (this.buyFlag) {
        document.body.style.overflow = 'scroll'
        return
      }
      this.buyFlag = true
      App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
      App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
      if (this.isExistDelivery) {
        App.setLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS, this.selBusiness)
      }
      App.setLocalStorage(DC_STORAGE_KEY.TOP_FORM, this.topForm)
      this.addCart()
    },
    // 入力チェック
    postcdCompleteDelivery: async function () {
      console.log('do postcdCompleteDelivery1')
      await FormUtil.addressCompletion(this.deliveryForm.postcd, (address) => {
        this.$set(this.deliveryForm, 'state', address.state)
        this.$set(this.deliveryForm, 'city', address.city)
        this.$set(this.deliveryForm, 'street', address.street)
        // チェック処理
        console.log('do postcdCompleteDelivery2')
      })
    },
    postcdCompleteStruct: async function () {
      console.log('do postcdCompleteStruct1')
      if (!this.workFlag) return
      let postcd = this.constructForm.postcd
      if (this.isStructSameAddress) {
        postcd = this.deliveryForm.postcd
      }
      await FormUtil.addressCompletion(postcd, (address) => {
        this.$set(this.constructForm, 'state', address.state)
        this.$set(this.constructForm, 'city', address.city)
        this.$set(this.constructForm, 'street', address.street)
        // チェック処理
        console.log('do postcdCompleteStruct2')
      })
    },
    postcdCompleteResrch: async function () {
      // 配送不可チェック
      if (!this.resrchFlag) return
      let postcd = this.resrchForm.postcd
      if (this.isResrchSameAddress) {
        postcd = this.deliveryForm.postcd
      }
      await FormUtil.addressCompletion(postcd, (address) => {
        this.$set(this.resrchForm, 'state', address.state)
        this.$set(this.resrchForm, 'city', address.city)
        this.$set(this.resrchForm, 'street', address.street)
      })
    },
    checkInputParam: function () {
      console.log('check input param')
      // 入力チェック
      this.errors = {}
      // 配送不可チェック
      if (!this.validateDeliImpossiblePostCd(this.deliveryForm.postcd, this.deliErrMessage)) {
        console.log('delivery postcd is impossible.')
        return false
      }
      let isCheckParam = this.$refs.paramCommonRef.checkParam()
      this.validateProductCnt()
      this.validateColor()
      this.validateRequireDeliveryPostcd()
      if (this.isConstruct) {
        this.validateRequireConstructPostcd()
      }
      if (this.resrchFlag) {
        this.validateRequireResrchPostcd()
      }
      if (Object.keys(this.errors).length !== 0 || !isCheckParam) {
        this.showErrorInput()
        return false
      }
      return true
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    convertHalfNumber: function (event) {
      // 郵便番号や電話番号で最初に0がくる場合があるため別で用意
      let str = FormUtil.restHalfNumber(event.target.value)
      return str
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      str = FormUtil.deleteTopZero(str)
      return str
    },
    validateProductCnt: function () {
      let ret = true
      if (!Check.isNumber(this.productCount)) {
        this.errors['product'] = 'ご注文数は数値で入力してください。'
        ret = false
      } else {
        delete this.errors.product
        ret = true
      }
      this.$forceUpdate()
      return ret
    },
    validateColor: function () {
      let ret = true
      if (!this.colorDoor && !this.colorCabine && !this.colorCounter) {
        this.errors['Color'] = 'カラーが選択されていません。'
        ret = false
      } else {
        delete this.errors.Color
      }
      this.$forceUpdate()
      return ret
    },
    validateRequireDeliveryPostcd: function () {
      let ret = true
      // 登録済みを選択して、保存リストを選択していなかった場合
      if (this.isExistDelivery && Object.keys(this.selBusiness).length === 0) {
        this.errors['selectList'] = '項目を選択してください'
        ret = false
      } else if (!this.deliveryForm.postcd && this.deliveryForm.postcd.length <= 0) {
        this.errors['deliveryPostcd'] = this.label.postcd + 'は必須項目です'
        ret = false
      } else if (!Check.isPostCd(this.deliveryForm.postcd)) {
        this.errors['deliveryPostcd'] = this.label.postcd + 'は半角数値7桁で入力してください。'
        ret = false
      } else if (!FormUtil.isExistPostcd(this.deliveryForm.postcd)) {
        this.errors['deliveryPostcd'] = this.label.postcd + 'が存在しません。'
        ret = false
      } else if (this.deliveryForm.postcd.length > 0 && (!this.deliveryForm.state || !this.deliveryForm.city || !this.deliveryForm.street)) {
        this.errors['deliveryPostcd'] = this.label.postcd + 'が間違っています'
        return false
      } else {
        delete this.errors.deliveryPostcd
      }
      this.$forceUpdate()
      return ret
    },
    validateRequireConstructPostcd: function () {
      let ret = true
      // 登録済みを選択して、保存リストを選択していなかった場合
      if (!this.isStructSameAddress) {
        if (!this.constructForm.postcd && this.constructForm.postcd.length <= 0) {
          this.errors['constructPostcd'] = this.label.postcd + 'は必須項目です'
          ret = false
        } else if (!Check.isPostCd(this.constructForm.postcd)) {
          this.errors['constructPostcd'] = this.label.postcd + 'は半角数値7桁で入力してください。'
          ret = false
        } else if (!FormUtil.isExistPostcd(this.constructForm.postcd)) {
          this.errors['constructPostcd'] = this.label.postcd + 'が存在しません。'
          ret = false
        } else if (this.constructForm.postcd.length > 0 && (!this.constructForm.state || !this.constructForm.city || !this.constructForm.street)) {
          this.errors['constructPostcd'] = this.label.postcd + 'が間違っています'
          return false
        } else {
          delete this.errors.constructPostcd
        }
      }
      this.$forceUpdate()
      return ret
    },
    validateRequireResrchPostcd: function () {
      let ret = true
      // 登録済みを選択して、保存リストを選択していなかった場合
      if (!this.isResrchSameAddress) {
        if (!this.resrchForm.postcd && this.resrchForm.postcd.length <= 0) {
          this.errors['resrchPostcd'] = this.label.postcd + 'は必須項目です'
          ret = false
        } else if (!Check.isPostCd(this.resrchForm.postcd)) {
          this.errors['resrchPostcd'] = this.label.postcd + 'は半角数値7桁で入力してください。'
          ret = false
        } else if (!FormUtil.isExistPostcd(this.resrchForm.postcd)) {
          this.errors['resrchPostcd'] = this.label.postcd + 'が存在しません。'
          ret = false
        } else if (this.resrchForm.postcd.length > 0 && (!this.resrchForm.state || !this.resrchForm.city || !this.resrchForm.street)) {
          this.errors['resrchPostcd'] = this.label.postcd + 'が間違っています'
          return false
        } else {
          delete this.errors.resrchPostcd
        }
      }
      this.$forceUpdate()
      return ret
    },
    validateDeliImpossiblePostCd: function (postcd, message) {
      if (!Check.checkDeliImposible(postcd)) {
        AppEc.showModal({
          messages: message,
          onCancel: this.newTabSupport,
          modalType: 'confirm',
          okBtnLabel: 'キャンセル',
          cancelBtnLabel: 'お問い合わせ',
          layoutType: 'classic',
          textAlign: 'left'
        })
        return false
      }
      return true
    },
    // 商品寸法
    onBlurOpShelfCount: function () {
      if (!this.dcShelfCount || this.dcShelfCount <= 0) {
        this.dcShelfCount = 0
      }
    },
    onBlurOpBoardCount: function () {
      if (!this.dcBoardCount || this.dcBoardCount <= 0) {
        this.dcBoardCount = 1
      }
    },
    onBlurOpFillerCount: function () {
      if (!this.dcFillerCount || this.dcFillerCount <= 0) {
        this.dcFillerCount = 0
      }
    },
    onBlurProductCount: function () {
      this.$refs.DcCustomizePriceHrf.loadingOn()
      if (!this.targetPlan.dcProductCount || this.targetPlan.dcProductCount <= 0) {
        this.targetPlan.dcProductCount = 1
      }
    },
    // カラー
    selectDoorColor: function (color) {
      this.colorDoor = color
    },
    selectCabineColor: function (color) {
      this.colorCabine = color
    },
    selectCounterColor: function (color) {
      this.colorCounter = color
    },
    getImage: function (image) {
      if (image === undefined) return
      return App.getMmstyleResource(image)
    },
    getYaImage: function (image) {
      return App.getYasumokuResource(image)
    },
    getContents: function (content) {
      return App.getHakotanContents(content)
    },
    // 注文
    addCart: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios.get(DC_URL.TOP + '/buy')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            this.$refs.loadingModalRef.showModal(false)
          } else {
            this.$store.dispatch('loadCartData')
            AppEc.showModal({
              title: '',
              messages: ['商品がカートに追加されました。'],
              messageType: 'success',
              layoutType: 'layout-classic',
              modalType: 'confirm',
              textAlign: 'center',
              okBtnLabel: '閉じる',
              cancelBtnLabel: 'カートを見る',
              onOk: () => {
                // 特になし
                document.body.style.overflow = 'scroll'
              },
              onCancel: () => {
                this.$router.push({
                  name: 'Cart'
                })
                document.body.style.overflow = 'scroll'
              }
            })
            this.$refs.loadingModalRef.showModal(false)
          }
        }).catch(error => {
          document.body.style.overflow = 'scroll'
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
          AppEc.showModal({
            title: 'システムエラー',
            messages: ['何らかの理由で不具合が発生しました。\nもう一度ページを開き直しても正しく表示されない時は、しばらく時間をおいてからお試しください。'],
            messageType: 'error',
            textAlign: 'left'
          })
          this.$refs.loadingModalRef.showModal(false)
        }).finally(() => {
          this.buyFlag = false
        })
    },
    resrch: async function () {
      // 多重防止
      if (this.doResrchFlag) return
      this.doResrchFlag = true
      this.errors = {}
      this.$refs.loadingModalRef.showModal(true)
      // await Promise.all([this.postcdCompleteDelivery(), this.postcdCompleteStruct(), this.postcdCompleteResrch()])
      await this.postcdCompleteDelivery()
      await this.postcdCompleteStruct()
      await this.postcdCompleteResrch()
      // チェック処理
      if (!this.checkInputParam()) {
        this.doResrchFlag = false
        this.$refs.loadingModalRef.showModal(false)
        return
      }
      // 画面データを渡す
      let payload = this.topForm
      axios.post(DC_URL.TOP + '/order', payload
      ).then(response => {
        if (response.data.errorMessage) {
          this.handleErrorMessage(response)
          this.$refs.loadingModalRef.showModal(false)
        } else {
          App.removeLocalStorage(DC_STORAGE_KEY.PREF_RESEARCH)
          App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_CHECKED)
          App.removeLocalStorage(DC_STORAGE_KEY.TOP_FORM)
          App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
          // 金額とファイルを更新
          this.priceData = Object.assign({}, response.data.data.priceData)
          this.profitPriceData = Object.assign({}, response.data.data.profitPriceData)
          this.spaceJoincd = response.data.data.spaceJoincd
          // ダイアログ表示
          let modalData = {
            onOk: () => {
              document.body.style.overflow = 'scroll'
              let topForm = {
                fileName: this.itemName,
                categoryId: this.targetPlan.dcCategoryType,
                topSpace: this.targetPlan,
                titleDoor: '扉カラー',
                colorDoor: this.colorDoor,
                titleCabine: 'キャビネット/棚/脚カラー',
                colorCabine: this.colorCabine,
                titleCounter: 'カウンターカラー',
                colorCounter: this.colorCounter,
                dcWorkFlag: this.isConstruct,
                isLeftFiller: this.isLeftFiller,
                isRightFiller: this.isRightFiller,
                dcShelfCount: this.opShelfCount,
                dcFillerCount: this.isAddFiller ? this.dcFillerCount : 0,
                spaceJoincd: this.spaceJoincd,
                dcProductCount: this.productCount,
                pageList: this.getPageList,
                postcd: this.resrchForm.postcd,
                state: this.resrchForm.state,
                city: this.resrchForm.city,
                street: this.resrchForm.street,
                resrchFlag: this.resrchFlag
              }
              App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
              App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
              App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
              App.removeLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
              if (this.isExistDelivery && this.isResrchSameAddress) {
                App.setLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS, this.selBusiness)
              }
              App.setLocalStorage(DC_STORAGE_KEY.TOP_FORM, topForm)
              App.setLocalStorage(DC_STORAGE_KEY.PRICE_DATA, this.priceData)
              this.$router.push({
                name: 'BuildingResearchBusiness'
              })
            },
            showSuccess: () => {
              this.$refs.loadingModalRef.showModal(false)
              document.body.style.overflow = 'hidden'
            },
            onSupport: () => {
              document.body.style.overflow = 'scroll'
              this.$router.push({
                name: 'SupportInput',
                query: {maker: this.targetPlan.corpData.corpId}
              })
            },
            dcFdId: this.targetPlan.dcFdId,
            fileName: this.itemName,
            titleDoor: '扉カラー',
            colorDoor: this.colorDoor,
            titleCabine: 'キャビネット/棚/脚カラー',
            colorCabine: this.colorCabine,
            titleCounter: 'カウンターカラー',
            colorCounter: this.colorCounter,
            priceData: this.priceData,
            targetPlan: this.topForm,
            spaceJoincd: this.spaceJoincd,
            dispOrderButton: true,
            dcProductCount: this.productCount,
            isCalcDelivery: true,
            isDrawing: this.targetPlan.dcCategoryType !== 5,
            corpData: this.targetPlan.corpData,
            isProductData: true,
            resrchFlag: this.resrchFlag === 1
          }
          AppEc.showEstimateModal(modalData)
          this.doResrchFlag = false
        }
      }).catch(error => {
        document.body.style.overflow = 'scroll'
        Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        AppEc.showModal({
          title: 'システムエラー',
          messages: ['何らかの理由で不具合が発生しました。\nもう一度ページを開き直しても正しく表示されない時は、しばらく時間をおいてからお試しください。'],
          messageType: 'error',
          textAlign: 'left'
        })
        this.$refs.loadingModalRef.showModal(false)
        this.doResrchFlag = false
      }).finally(() => {
      })
    },
    // 見積りダイアログ系
    doorColorContentNo: function () {
      if (this.doorColorList.length > 0) {
        return 1
      }
    },
    boxColorContentNo: function () {
      if (this.doorColorList.length > 0 && this.cabineColorList.length > 0) {
        return 2
      } else if (this.cabineColorList.length > 0) {
        return 1
      }
    },
    counterColorContentNo: function () {
      if (this.doorColorList.length > 0 && this.cabineColorList.length > 0 && this.counterColorList.length > 0) {
        return 3
      } else if ((this.doorColorList.length > 0 || this.cabineColorList.length > 0) && this.counterColorList.length > 0) {
        return 2
      } else {
        return 1
      }
    },
    // システム系
    setPriceCalcTimer: function () {
      if (this.priceCalcTimer) return
      let _this = this
      this.priceCalcTimer = function () {
        _this.priceCalcText = _this.priceCalcText.replace('...', '') + '.'
      }
      setInterval(this.priceCalcTimer, 1000)
    },
    clearPriceCalcTimer: function () {
      clearInterval(this.priceCalcTimer)
    },
    changeWallFlag: function (flg) {
      this.isWallEmbedded = flg
    },
    newTabSupport: function () {
      let newWindow = window.open('/#/support/input', 'support')
      newWindow.location.reload()
    },
    showErrorInput: function () {
      AppEc.showModal({
        messages: ['入力内容を確認してください。'],
        onOk: this.onNew
      })
    },
    bigImage: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return file + '_B' + exp
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    sizeName: function (w, h, d) {
      if (!w || !h || !d) return ''
      return w + '×' + h + '×' + d + '(mm)'
    },
    productSize: function (min, max) {
      return (min + ' ≦ W ≦ ' + max)
    },
    handleErrorMessage: function (response) {
      if (!response || !response.data) {
        return
      }
      let modalData = {
        title: 'エラー',
        messages: response.data.errorMessage.split(/\r?\n/g),
        messageType: 'error',
        textAlign: 'left'
      }
      AppEc.showModal(modalData)
    },
    changeResrchAdress: function () {
      if (this.isResrchSameAddress) {
        this.copyForm = Object.assign({}, this.resrchForm)
        this.$set(this.resrchForm, 'postcd', this.deliveryForm.postcd)
      } else {
        this.resrchForm = Object.assign(this.resrchForm, this.copyForm)
      }
    },
    changeNewInput: function () {
      delete this.errors.selectList
      delete this.errors.deliveryPostcd
      if (this.isExistDelivery) {
        // 新規から既存に切り替わったとき
        // 新規で入力していた値を一時退避
        this.saveForm = Object.assign({}, this.deliveryForm)
        if (this.selBusiness) {
          this.$set(this.deliveryForm, 'postcd', this.selBusiness.postcd)
        }
      } else {
        // 既存から新規に切り替わったとき
        if (Object.keys(this.saveForm).length > 0) {
          // 新規で入力していたら退避していた値を戻す
          this.deliveryForm = Object.assign({}, this.saveForm)
        } else {
          this.$set(this.deliveryForm, 'postcd', '')
        }
      }
    },
    changeNewStruct: function () {
      delete this.errors.constructPostcd
      if (!this.isStructSameAddress) {
        // 既存から新規に切り替わったとき
        if (Object.keys(this.saveConstructForm).length > 0) {
          // 新規で入力していたら退避していた値を戻す
          this.constructForm = Object.assign({}, this.saveConstructForm)
        } else {
          this.$set(this.constructForm, 'postcd', '')
        }
      } else {
        // 新規から既存に切り替わったとき
        // 新規で入力していた値を一時退避
        this.saveConstructForm = Object.assign({}, this.constructForm)
        this.$set(this.constructForm, 'postcd', this.deliveryForm.postcd)
      }
    },
    changeResrch: function (status) {
      if (status === 1) {
        delete this.errors.selectList
        delete this.errors.deliveryPostcd
      } else {
        delete this.errors.resrchPostcd
      }
      this.$forceUpdate()
    },
    onMenu: function () {
      if (this.isMenuActive) {
        this.isMenuActive = false
      } else {
        this.isMenuActive = true
      }
    },
    downloadManual: function (fileName) {
      let link = document.createElement('a')
      link.href = this.getContents(fileName)
      window.open(link)
    },
    goCategory: function () {
      this.$router.push({
        name: 'DcTop'
      })
    },
    categoryImgBlack: function (imgName) {
      if (!imgName) return undefined
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return this.getImage('category/' + file + '_black' + exp)
    },
    previewConstruct: function (obj) {
      let modalData = {
        image: obj.imgB
      }
      AppEc.showImageViewerModal(modalData)
    },
    convertDcFileData: function (data) {
      let dcFileData = {
        dcFdId: data.dcFdId,
        dcCategoryType: data.dcCategoryType,
        dcFdName: data.dcFdName,
        dcFileName: data.dcFileName,
        seriesName: data.seriesName,
        dcFdType: data.dcFdType,
        dcFdImage: data.dcFdImage,
        dcFdImageB: this.bigImage(data.dcFdImage),
        dcWidth: data.defW,
        dcMinWidth: data.minW,
        dcMaxWidth: data.maxW,
        dcHeight: data.defH,
        dcMinHeight: data.minH,
        dcMaxHeight: data.maxH,
        dcDepth: data.defD,
        dcMinDepth: data.minD,
        dcMaxDepth: data.maxD,
        dcHeight2: data.defH2,
        dcWidth2: data.defW2,
        dcMinWidth2: data.minW2,
        dcMaxWidth2: data.maxW2,
        dcMinHeight2: data.minH2,
        dcMaxHeight2: data.maxH2,
        dcDepth2: data.defD2,
        dcMinDepth2: data.minD2,
        dcMaxDepth2: data.maxD2,
        dcBType: data.btype,
        dcBSize: data.bsize,
        dcCType: data.ctype,
        dcCSize: data.csize,
        dcDType: data.dtype,
        dcDSize: data.dsize,
        dcProductCount: 1,
        dcBTypeDisableFlg: data.btypeDisableFlg,
        dcCTypeDisableFlg: data.ctypeDisableFlg,
        dcDTypeDisableFlg: data.dtypeDisableFlg,
        opShelfDisableFlg: data.opShelfDisableFlg,
        opFillerDisableFlg: data.opFillerDisableFlg,
        opShelfType: data.opShelfType,
        opFillerType: data.opFillerType,
        corpData: data.corpData,
        inputReferenceList: data.inputReferenceList,
        cDcProductManual: data.dcProductManual,
        cDcConstructManual: data.dcConstructManual,
        cDcUserManual: data.dcUserManual,
        categoryImg: data.categoryImg,
        categoryName: data.categoryName,
        consentImg: data.consentImg
      }
      return dcFileData
    },
    changeColorStyle: function (style) {
      this.selectColorStyle = style
      // 初期カラー選択
      this.$nextTick(function () {
        if (this.doorColorList.length > 0) {
          this.selectDoorColor(this.doorColorList[0])
        } else {
          this.selectDoorColor(null)
        }
        if (this.cabineColorList.length > 0) {
          this.selectCabineColor(this.cabineColorList[0])
        } else {
          this.selectCabineColor(null)
        }
        if (this.counterColorList.length > 0) {
          this.selectCounterColor(this.counterColorList[0])
        } else {
          this.selectCounterColor(null)
        }
        console.log('selectedPlan end color')
      })
    },
    filterColorStyleList: function (colorList) {
      return colorList.filter(c => c.style === 0 || c.style === this.selectColorStyle.colorStyleNo)
    },
    isOnReload: function (on) {
      if (on) {
        this.imgReload = this.getImage('common/reload_white.svg')
      } else {
        this.imgReload = this.getImage('common/reload_black.svg')
      }
    },
    isOnSave: function (on) {
      if (on) {
        this.imgSave = this.getImage('common/save_orange.svg')
      } else {
        this.imgSave = this.getImage('common/save_black.svg')
      }
    }
  }, // end methods
  computed: {
    // ヘッダのカート情報
    ...mapState({
      cartData: state => state.cartData, deliveryDestList: state => state.deliveryDestList
    }),
    nowList: function () {
      if (!this.cartData || !this.cartData.cartModel || Object.keys(this.cartData.cartModel.orderList).length <= 0) return {}
      return this.cartData.cartModel.orderList
    },
    // 全体
    topForm: function () {
      let param = this.$refs.paramCommonRef.getParam()
      let payload = {
        dcFdId: this.targetPlan.dcFdId,
        dcCode: this.targetPlan.dcFdCode,
        dcWidth: param.width,
        dcWidth2: param.width2,
        dcHeight: param.height,
        dcHeight2: param.height2,
        dcDepth: param.depth,
        dcDepth2: param.depth2,
        dcBType: param.fillerTypeLeft,
        dcBSize: param.fillerSizeLeft,
        dcCType: param.fillerTypeRight,
        dcCSize: param.fillerSizeRight,
        dcDType: param.fillerTypeCounter,
        dcDSize: param.fillerSizeCounter,
        colorStyleNo: this.selectColorStyle.colorStyleNo,
        dcColorDoor: this.colorDoor !== null ? this.colorDoor.id : null,
        dcColorBox: this.colorCabine !== null ? this.colorCabine.id : null,
        dcColorCounter: this.colorCounter !== null ? this.colorCounter.id : null,
        dcShelfCount: this.opShelfCount,
        dcFillerCount: this.isAddFiller ? this.dcFillerCount : 0,
        dcWorkFlag: this.isConstruct,
        dcProductCount: this.productCount,
        dcSaveResrchFlag: this.resrchFlag === 1,
        dcSaveExistDeliFlag: this.isExistDelivery,
        dcSaveDeliPostcd: this.deliveryForm.postcd,
        dcSaveDeliState: this.deliveryForm.state,
        dcSaveDeliCity: this.deliveryForm.city,
        dcSaveDeliStreet: this.deliveryForm.street,
        dcStructPostcd: this.isStructSameAddress ? this.deliveryForm.postcd : this.constructForm.postcd,
        dcStructState: this.isStructSameAddress ? this.deliveryForm.state : this.constructForm.state,
        dcStructCity: this.isStructSameAddress ? this.deliveryForm.city : this.constructForm.city,
        dcStructStreet: this.isStructSameAddress ? this.deliveryForm.street : this.constructForm.street,
        dcConstructOpServiceFlag: false,
        businessId: this.selBusiness ? this.selBusiness.businessId : undefined,
        categoryId: this.targetPlan.dcCategoryType,
        makerCorpId: this.targetPlan.corpId,
        colorTypeNo: this.targetPlan.dcFdColorType,
        dcStructSameAddressFlag: this.isStructSameAddress,
        dcSaveExistResrchFlag: false,
        dcSaveSameAddressFlag: this.isResrchSameAddress,
        dcSaveResrchPostcd: this.resrchForm.postcd
      }
      return payload
    },
    // 商品
    isSpaceJoincd: function () {
      if (!this.spaceJoincd) return false
      return true
    },
    // 納品先
    addressList: function () {
      if (!this.deliveryDestList || Object.keys(this.deliveryDestList).length <= 0) return []
      return this.deliveryDestList.map(e => {
        let list = {
          businessId: e.cdeliveryId,
          corpId: e.ccorpId,
          userId: e.cuserId,
          businessName: e.cdeliveryName,
          building: e.cdelvieryBuilding,
          postcd: e.cdeliveryPostcd,
          state: e.cdeliveryState,
          city: e.cdeliveryCity,
          street: e.cdeliveryStreet,
          tel: e.ecdeliveryTel,
          userLastName: e.cdeliveryPersonLastName,
          userFirstName: e.cdeliveryPersonFirstName,
          userLastNameKana: e.cdeliveryPersonLastNameKana,
          userFirstNameKana: e.cdeliveryPersonFirstNameKana
        }
        return list
      })
    },
    // 色柄の名称
    doorColorTitle: function () {
      if (this.selectColorStyle && Object.keys(this.selectColorStyle).length > 0) {
        return '扉/エンドパネルのカラーをご選択ください。'
      } else {
        return '扉のカラーをご選択ください。'
      }
    },
    // 色柄
    cabineColorList: function () {
      let lColorList = this.colorList.filter(c => c.type === COLOR_MATERIAL_TYPE.CABINE.code)
      if (this.isExistEndPanel) {
        return this.filterColorStyleList(lColorList)
      }
      return lColorList
    },
    doorColorList: function () {
      let lColorList = this.colorList.filter(c => c.type === COLOR_MATERIAL_TYPE.DOOR.code)
      if (this.isExistEndPanel) {
        return this.filterColorStyleList(lColorList)
      }
      return lColorList
    },
    counterColorList: function () {
      let lColorList = this.colorList.filter(c => c.type === COLOR_MATERIAL_TYPE.COUNTER.code)
      if (this.isExistEndPanel) {
        return this.filterColorStyleList(lColorList)
      }
      return lColorList
    },
    isExistEndPanel: function () {
      if (this.selectColorStyle && Object.keys(this.selectColorStyle).length > 0) {
        return true
      }
      return false
    },
    // 注文
    isExecOrder: function () {
      if (this.productCount <= 0) return false
      if (!this.colorDoor && !this.colorCabine && !this.colorCounter) return false
      if ((this.colorDoor && Object.keys(this.colorDoor).length <= 0) &&
         (this.colorCabine && Object.keys(this.colorCabine).length <= 0) &&
         (this.colorCounter && Object.keys(this.colorCounter).length <= 0)) return false
      if (this.isPlanning) return false
      return true
    },
    getPageList: function () {
      let pageList = []

      if (this.resrchFlag === 1) {
        pageList.push({id: 'order', key: 'orderInput', title: '事前現場調査先入力'})
        pageList.push({id: 'input', key: 'buildingResearchInput', title: '事前現場調査項目入力'})
        pageList.push({id: 'confirm', key: 'orderConfirm', title: '事前現場調査内容確認'})
        pageList.push({id: 'complete', key: 'orderComp', title: '事前現場調査依頼完了'})
      } else {
        pageList.push({id: 'order', key: 'orderInput', title: '納品先入力'})
        if (this.isConstruct) {
          pageList.push({id: 'struct', key: 'struct', title: '組立設置情報入力'})
        }
        pageList.push({id: 'confirm', key: 'orderConfirm', title: 'ご注文内容確認'})
        if (!this.userInfo.isAccountPay) {
          pageList.push({id: 'payment', key: 'payment', title: 'お支払い方法選択'})
        }
        pageList.push({id: 'complete', key: 'orderComp', title: '注文完了'})
      }
      return pageList
    },
    isOutputCG: function () {
      return (this.userInfo && this.userInfo.menuServiceCode && this.userInfo.menuServiceCode.outputCg)
    },
    isResearch: function () {
      return (this.targetPlan.dcCategoryType !== 5)
    },
    estimteBtnTitle: function () {
      if (this.targetPlan.dcCategoryType === 5) return '見積り'
      // return '図面/見積り'
      return '金額・商品図面を確認する'
    },
    opShelfCount: function () {
      if (this.targetPlan.dcCategoryType === 5) {
        return this.dcBoardCount ? this.dcBoardCount : 0
      }
      return this.isAddShelf ? this.dcShelfCount : 0
    },
    isPlanning: function () {
      return this.createPlanFlag
    },
    isSelectConstruct: function () {
      if (this.targetPlan.dcCategoryType === 4) {
        return !this.isWallEmbedded
      }
      return true
    },
    isConstruct: function () {
      if (!this.isSelectConstruct) return false
      return this.workFlag === 1
    },
    isMiuraCompany: function () {
      if (!this.targetPlan.corpData) return false
      if (this.targetPlan.corpData.corpId === 1001) {
        return true
      }
      return false
    },
    fillerSize: function () {
      if (this.isMiuraCompany) {
        return 20
      } else {
        return 15
      }
    },
    isGuestUser: function () {
      if (!this.userInfo || this.userInfo.userLevel === 4) {
        return true
      }
      return false
    },
    isTypeBeamCounter: function () {
      if (this.isDomans) return false
      if (this.dtype === 5) {
        return true
      }
      return false
    },
    isParamShelfBoard: function () {
      if (this.id === 151 || this.id === 152) return true
      if (this.isDomans) return true
      if (this.isOlis) return true
      if (this.id >= 4005 && this.id <= 4029) return true
      if (this.categoryType === 5) return true
      if (this.categoryType === 17) return true
      return false
    },
    isViewConstruct: function () {
      if (this.isDomans) return false
      if (this.targetPlan.dcCategoryType === 4 && this.targetPlan.corpData.corpId === 1070) return false
      if (this.targetPlan.dcCategoryType !== 5) return true
      return false
    },
    isOlis: function () {
      if (this.id > 2000 && this.id < 2117) return true
      return false
    },
    isDomans: function () {
      if (this.id > 2999 && this.id < 3206) return true
      if (this.id > 3205 && this.id < 3360) return true
      if (this.id > 3369 && this.id < 3380) return true
      return false
    },
    isOtherContruct: function () {
      if (this.categoryType === 17) return true
      return false
    },
    isShelf: function () {
      return this.isDomans
    },
    isShelfType: function () {
      if (this.id > 2999 && this.id < 3043) return 1
      if (this.id > 3033 && this.id < 3054) return 2
      if (this.id > 3054 && this.id < 3065) return 1
      if (this.id === 3066) return 2
      if (this.id > 3067 && this.id < 3079) return 1
      if (this.id === 3080) return 2
      if (this.id > 3081 && this.id < 3106) return 1
      if (this.id === 3107) return 2
      if (this.id > 3108 && this.id < 3120) return 1
      if (this.id === 3121) return 2
      if (this.id > 3122 && this.id < 3134) return 1
      if (this.id === 3135) return 2
      if (this.id > 3136 && this.id < 3147) return 1
      if (this.id === 3148) return 2
      if (this.id > 3149 && this.id < 3161) return 1
      if (this.id === 3162) return 2
      if (this.id > 3163 && this.id < 3175) return 1
      if (this.id === 3176) return 2
      if (this.id > 3177 && this.id < 3189) return 1
      if (this.id === 3190) return 2
      if (this.id > 3191 && this.id < 3206) return 2
      if (this.id > 3205 && this.id < 3360) return 2
      if (this.id > 3369 && this.id < 3380) return 2
      return 0
    },
    // subTotalPrice: function () {
    //   let price = this.priceData.itemPrice * this.priceData.productCount
    //   price += this.priceData.itemTax * this.priceData.productCount
    //   return price
    // },
    // deliveryTotalPrice: function () {
    //   let price = this.priceData.delivaryPrice * this.priceData.productCount
    //   price += this.priceData.deliveryTax * this.priceData.productCount
    //   return price
    // },
    // constructTotalPrice: function () {
    //   let price = this.priceData.constructPrice * this.priceData.productCount
    //   price += this.priceData.constructTax * this.priceData.productCount
    //   return price
    // },
    // executionTotalPrice: function () {
    //   let price = this.priceData.executionVarExpensesPrice + this.priceData.executionVarExpensesTax
    //   return price
    // },
    isFiller: function () {
      if (this.id >= 4000 && this.id <= 4004) {
        return true
      }
      return false
    },
    sizeInputTitle: function () {
      if (this.id > 3205 && this.id < 3356) return '■商品サイズ'
      return '■商品サイズの入力'
    },
    productCount: function () {
      if (this.targetPlan.dcCategoryType === 5) return 1
      if (this.$refs.ddCounterRef) return this.$refs.ddCounterRef.getCount()
      return 0
    }
  }, // end computed
  watch: {
    'deliveryForm.postcd': function () {
      if (this.isStructSameAddress) {
        this.$set(this.constructForm, 'postcd', this.deliveryForm.postcd)
      }
      if (this.isResrchSameAddress) {
        this.$set(this.resrchForm, 'postcd', this.deliveryForm.postcd)
      }
    }
  },
  mounted: function () {
    console.log('mounted')
    document.body.style.overflow = 'scroll'
    App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
    // 登録先
    // 保存リスト or 通常
    let saveProduct = App.getLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.id = this.$route.query.id ? Number(this.$route.query.id) : undefined
    this.categoryType = this.$route.query.ctype ? Number(this.$route.query.ctype) : undefined
    this.dtype = this.$route.query.dtype ? Number(this.$route.query.dtype) : undefined
    if (!saveProduct || Object.keys(saveProduct).length <= 0) {
      console.log('sync')
      // カテゴリ決定
      if (!this.id || !this.categoryType) {
        this.$router.push({
          name: 'DcError'
        })
      }
      this.syncLogin(this.$route.query.id)
    } else {
      console.log('save')
      this.readSaveParam(saveProduct.categoryId, saveProduct)
    }
    App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)

    // カート情報取得
    this.$store.dispatch('loadCartData', {reload: true})
    this.$store.dispatch('loadDeliveryDest', {reload: true})
  },
  created: function () {
    console.log('create')
    // 履歴削除
    let pageList = App.getLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
    if (Object.keys(pageList).length > 0) {
      // 履歴の進むを消す
      history.pushState(null, 'TOP', null)
      App.removeLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
    }
    this.setPriceCalcTimer()
  }
}
</script>
<style src="../css/dctop.scss" lang="scss" scoped></style>
<style src="../css/dc-customize.scss" lang="scss" scoped></style>
<style src="../css/dc-common.scss" lang="scss" scoped></style>
<style src="../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcCustomize.vue